import { z } from 'zod';
import { PinSchema } from '../common/pin.js';
/**
 * `POST /auth/pin/change` — also satisfies `must_change_pin`
 * (03-API-CONTRACT.md §1). Both PINs are 6 digits; a refinement rejects
 * `newPin === currentPin` since a "change" that changes nothing is not a
 * real state transition (ambiguity resolution — the docs don't say this
 * explicitly, but D-05's weak-PIN spirit implies it, and `WEAK_PIN` /
 * `INVALID_PIN` alone don't cover "PIN unchanged").
 */
export const PinChangeRequestSchema = z
    .object({
    currentPin: PinSchema,
    newPin: PinSchema,
})
    .refine((v) => v.currentPin !== v.newPin, {
    error: 'newPin must differ from currentPin',
    path: ['newPin'],
});
/**
 * `accessToken` is not a convenience.
 *
 * The access JWT carries `mcp` (must-change-pin) as a claim so the guard costs
 * no query, which means a token minted with the one-time PIN keeps saying
 * "this user must change their PIN" after they have. Clearing the column does
 * not clear the claim in a token already in the client's hands, and every
 * route but the escape hatches answers `403 PIN_CHANGE_REQUIRED` to it. Only
 * the server can mint the replacement, and this is the response that knows the
 * old one just went stale — so it hands the new one back rather than leaving
 * every client to discover the problem through a 403 it has no reason to
 * retry.
 */
export const PinChangeResponseSchema = z.object({
    mustChangePin: z.literal(false),
    accessToken: z.string().min(1),
});
//# sourceMappingURL=pin-change.js.map